import React from "react";
import { Row, Col } from "antd";
import { useAppContext } from "../../../context/AppContext";
import InboundCard from "./inboundCard";
import { updateInbound } from "../../../actions/appActions";

const InboundCardsContainer = props => {
    const {
        state: { inbound },
        dispatch: appDispatch,
    } = useAppContext();
    const { plans } = props;
    if (!plans) return null;

    const handleClick = planHandle => {
        appDispatch(
            updateInbound({
                planHandle,
            })
        );
    };

    return (
        plans.length > 1 && (
            <div style={{ margin: "1rem 0" }}>
                <Row type="flex" justify="center" gutter={16}>
                    {plans.map((plan, key) => (
                        <Col
                            xs={24}
                            sm={8}
                            xl={8}
                            style={{ marginBottom: "1rem", maxWidth: "280px" }}
                            key={key}
                        >
                            <InboundCard
                                inboundPlan={plan}
                                highlighted={plan.planHandle === inbound.planHandle}
                                handleClick={() => handleClick(plan.planHandle)}
                            />
                        </Col>
                    ))}
                </Row>
            </div>
        )
    );
};

export default InboundCardsContainer;
